import { styled } from '@linaria/react'
import { MinimalSegmentedControl, type MinimalOption } from '@ovasabi/ui-minimal'
import { BowlIcon, ChefHatIcon } from '../../../components/icons'
import type { ChowRole } from '../../../lib/actor'

/**
 * Customer/chef switch for the auth screen. Composes the foundation
 * `MinimalSegmentedControl` (brand variant) rather than re-implementing the
 * sliding highlight — the indicator rides on framer's `layout` transition
 * (transform-only, reduced-motion aware), so the context switch is smooth. The
 * crimson-filled look comes from `variant="brand"`; icons ride in the option
 * labels (which accept any ReactNode).
 */
const Label = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const OPTIONS: readonly MinimalOption<ChowRole>[] = [
  {
    value: 'customer',
    label: (
      <Label>
        <BowlIcon size="sm" /> Customer
      </Label>
    ),
  },
  {
    value: 'chef',
    label: (
      <Label>
        <ChefHatIcon size="sm" /> Chef
      </Label>
    ),
  },
]

export const RoleToggle = ({
  value,
  onChange,
}: {
  value: ChowRole
  onChange: (role: ChowRole) => void
}) => (
  <MinimalSegmentedControl
    variant="brand"
    ariaLabel="Account type"
    value={value}
    options={OPTIONS}
    onChange={onChange}
    style={{ display: 'flex', width: '100%' }}
  />
)
